/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const UpdateDestinationRequest = zod
	.object({
		endpoint: zod.url().optional().describe('Webhook endpoint URL'),
		events: zod.array(zod.string()).optional().describe('List of event types to subscribe to'),
		status: zod.enum(['active', 'broken', 'disabled'])
	})
	.describe('Request body for updating an event destination');

export type UpdateDestinationRequest = zod.input<typeof UpdateDestinationRequest>;
export type UpdateDestinationRequestOutput = zod.output<typeof UpdateDestinationRequest>;
